import { Theme } from '@mui/material/styles';

import { spacing } from '~theme/AppTheme';

export const TIME_AND_DURATION_TRACK_VARIABLE = '--charges-time-and-duration-track';

export const HOURLY_TIME_AND_DURATION_TRACK = 'minmax(72px, 1fr)';

// The minimums keep the grid on a 1440px screen with its action column in view; a cell
// that outgrows its track truncates instead of widening the row. The last track fits an
// Approve button beside a menu.
export const CHARGES_GRID_TEMPLATE_COLUMNS = [
  '36px',
  'minmax(56px, 0.8fr)',
  'minmax(64px, 1fr)',
  'minmax(80px, 1.2fr)',
  'minmax(80px, 1.2fr)',
  'minmax(72px, 1fr)',
  'minmax(80px, 1.2fr)',
  'minmax(64px, 1fr)',
  `var(${TIME_AND_DURATION_TRACK_VARIABLE}, 0px)`,
  'minmax(64px, 0.9fr)',
  'minmax(64px, 0.9fr)',
  'minmax(80px, 1fr)',
  'minmax(80px, 1fr)',
  'minmax(64px, 0.8fr)',
  'minmax(64px, 0.8fr)',
  `calc(170px + ${spacing(2)})`,
].join(' ');

export const chargesGridColumn = {
  addOnActions: '1 / 10',
  addOnName: '3 / 10',
  addOnQuantity: '11',
  addOnRate: '10',
  addOnSide: '2',
  addOnTotalsLabel: '11',
  created: '3',
  customerAndProject: '4',
  date: '2',
  invoiceNumber: '15',
  loads: '10',
  material: '8',
  order: '3',
  payableAmount: '12',
  payableNumber: '14',
  receivableAmount: '13',
  route: '7',
  select: '1',
  status: '16',
  ticket: '4 / 7',
  ticketQuantity: '11',
  time: '2',
  timeAndDuration: '9',
  driverAndVendor: '5',
  truck: '6',
} as const;

export const CHARGES_CELL_SX = { overflow: 'hidden', p: 1 } as const;

export const chargesNestedHeaderRowSx = (theme: Theme) => ({
  bgcolor: theme.semantic.surfaceOverlay,
  borderBottom: `solid 1px ${theme.brandV2.colors.treadGray7}`,
  display: 'grid',
  gridTemplateColumns: CHARGES_GRID_TEMPLATE_COLUMNS,
});

export const CHARGES_NESTED_HEADER_CELL_SX = {
  overflow: 'hidden',
  px: 1,
  py: 0.75,
} as const;

export const chargesNestedHeaderTextSx = (theme: Theme) => ({
  color: theme.brandV2.colors.treadBlack,
  fontSize: '10px',
  fontWeight: 600,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
});

const ROW_TEXT_LINE_SELECTOR = 'p.MuiTypography-root';

const ROW_SECONDARY_LINE_SELECTORS = [
  `& > * > ${ROW_TEXT_LINE_SELECTOR} ~ ${ROW_TEXT_LINE_SELECTOR}`,
  `& > * > * > * ~ ${ROW_TEXT_LINE_SELECTOR}`,
].join(', ');

export const chargesRowTextSx = (theme: Theme) => ({
  [`& ${ROW_TEXT_LINE_SELECTOR}`]: { fontSize: '12px', lineHeight: '16px' },
  [ROW_SECONDARY_LINE_SELECTORS]: {
    color: theme.brandV2.colors.treadGray2,
    fontSize: '10px',
    height: 'auto',
    lineHeight: '14px',
  },
});

export const chargesListCardSx = (theme: Theme) => ({
  bgcolor: theme.semantic.surfaceRaised,
  border: `solid 1px ${theme.brandV2.colors.treadGray6}`,
  borderRadius: theme.spacing(),
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 2px 8px 0 rgba(0, 0, 0, 0.55)'
      : '0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
  overflow: 'hidden',
});

export const chargesRaisedCardSx = (theme: Theme) => ({
  bgcolor: theme.semantic.surfaceRaised,
  border: `1px solid ${theme.brandV2.colors.treadGray7}`,
  borderRadius: 2,
  boxShadow: theme.shadows[1],
});

export const rejectedAmountSx = (theme: Theme) => ({
  color: theme.palette.text.disabled,
  fontWeight: 400,
  textDecoration: 'line-through',
});

export const NO_VALUE_PLACEHOLDER = '—';
